// Webpack Imports
import * as bootstrap from "bootstrap";
import Swiper, { Navigation, Pagination } from "swiper";
import Accordion from "accordion-js";
import Alpine from "alpinejs";

Alpine.store("searchBox", {
    hasResults: false,
    open: false,
    term: "",
    results: [],
    toggle() {
        this.open = !this.open;
        if (!this.open) {
            this.clearSearch();
        }
    },
    clearSearch() {
        this.open = false;
        this.term = "";
        this.results = [];
    },
});
Alpine.start();

(function () {
    "use strict";

    document.addEventListener("DOMContentLoaded", () => {
        if (document.body.classList.contains("search")) {
            applySearchType();
        }
    });

    const anchors = document.querySelectorAll("a[href^='#']");
    anchors.forEach((a) => {
        a.addEventListener("click", (e) => {
            const url = e.target.getAttribute("href");
            // if (url.startsWith("#")) {
            // scrollToTargetAdjusted(url);
            // }
        });
    });

    function scrollToTargetAdjusted(target) {
        var element = document.getElementById(target.replace("#", ""));
        var headerOffset =
            document.querySelector("header fixed-top").offsetHeight;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
        el.addEventListener("submit", function (e) {
            var search = el.querySelector("input");
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    let player;
    const featuredVideo = document.querySelector(".section .featured-video");
    let videos = document.querySelectorAll(".videos .swiper .video");
    let singleVideo = document.querySelector(".single-video .video");
    let videoGuide = document.querySelectorAll(".video_guide .card");
    videos = Array.prototype.slice.call(videos);
    videos = [...videos, featuredVideo, singleVideo, ...videoGuide];
    videos.forEach((v) => {
        if (v) {
            v.addEventListener("click", (e) => {
                const src = v.getAttribute("src");
                const id = YouTubeGetID(src);
                const url = id;
                player = openVideoModal(url);
            });
        }
    });

    const modalBackdrop = document.getElementById("modal-backdrop");
    const videoCloseButton = document.querySelector("#video-modal .close");
    if (modalBackdrop) {
        modalBackdrop.addEventListener("click", (e) => {
            closeVideoModal();
        });
    }
    if (videoCloseButton) {
        videoCloseButton.addEventListener("click", (e) => {
            closeVideoModal();
        });
    }

    function openVideoModal(src) {
        document.body.classList.add("video-open");
        return onYouTubeIframeAPIReady(src);
    }

    function closeVideoModal() {
        document.body.classList.remove("video-open");
        if (player) {
            player.stopVideo();
            player.destroy();
        }
    }

    function onYouTubeIframeAPIReady(src) {
        var height = window.innerHeight * 0.9;
        return new YT.Player("player", {
            height: height,
            width: height * (1920 / 1080),
            videoId: src,
            playerVars: {
                playsinline: 1,
            },
            events: {
                onReady: onPlayerReady,
            },
        });
    }

    function onPlayerReady(event) {
        event.target.playVideo();
    }

    function YouTubeGetID(url) {
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: "hover",
        });
    });

    var accordionTag = document.querySelector(".accordion-container");
    if (accordionTag) {
        var accordion = new Accordion(".accordion-container", {
            beforeOpen: (el) => {
                faqAccordion();
            },
            onClose: (el) => {
                faqAccordion(true);
            },
            onOpen: (el) => {
                scrollToTargetAdjusted(el);
            },
        });
        var featureList = document.querySelectorAll(".features-list li");
        featureList.forEach((item) => {
            item.addEventListener("click", () => {
                var tab = item.dataset.tab;
                // console.log(tab);
                accordion.open(tab);
            });
        });
    }

    function scrollToTargetAdjusted(element) {
        var headerOffset = 120;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }

    var sliderSpeed = 600;
    Swiper.use([Navigation, Pagination]);
    const swiperProducts = new Swiper(".products .swiper", {
        spaceBetween: 17,
        slidesPerView: "auto",
        centeredSlides: false,
        grabCursor: true,
        speed: sliderSpeed,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    const swiperCategories = new Swiper(".categories .swiper", {
        spaceBetween: 17,
        slidesPerView: "auto",
        centeredSlides: false,
        grabCursor: true,
        speed: sliderSpeed,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const swiperFunctions = new Swiper(".functions .swiper", {
        spaceBetween: 17,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        centeredSlides: false,
        grabCursor: true,
        slidesPerGroup: 1,
        autoHeight: true,
    });
    var prev = document.querySelector(".functions-navigation .button-prev");
    var next = document.querySelector(".functions-navigation .button-next");
    if (prev && next) {
        prev.addEventListener("click", () => {
            swiperFunctions.slidePrev();
        });
        next.addEventListener("click", () => {
            swiperFunctions.slideNext();
        });
    }

    const swiperVideoGuide = new Swiper(".video_guide .swiper", {
        spaceBetween: 17,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        centeredSlides: false,
        grabCursor: true,
        slidesPerGroup: 1,
        autoHeight: true,
    });
    var prev = document.querySelector(".video_guide-navigation .button-prev");
    var next = document.querySelector(".video_guide-navigation .button-next");
    if (prev && next) {
        prev.addEventListener("click", () => {
            swiperVideoGuide.slidePrev();
        });
        next.addEventListener("click", () => {
            swiperVideoGuide.slideNext();
        });
    }

    const swiperPosts = new Swiper(".posts .swiper", {
        spaceBetween: 17,
        slidesPerView: "auto",
        centeredSlides: false,
        grabCursor: true,
        speed: sliderSpeed,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const swiperVideos = new Swiper(".videos .swiper", {
        centeredSlides: false,
        grabCursor: true,
        slidesPerView: 2,
        speed: sliderSpeed,
        breakpoints: {
            0: {
                spaceBetween: 17,
            },
            768: {
                spaceBetween: 34,
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    const swiperDocumentation = new Swiper(".documentation .swiper", {
        centeredSlides: false,
        grabCursor: true,
        speed: sliderSpeed,
        slidesPerView: "auto",
        spaceBetween: 17,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const swiperProductGallery = new Swiper(".post-thumbnail.gallery .swiper", {
        spaceBetween: 0,
        slidesPerView: 1,
        grabCursor: true,
        slidesPerGroup: 1,
        speed: sliderSpeed,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button.next",
            prevEl: ".swiper-button.prev",
        },
    });
    const sliders = {
        swiperProducts: swiperProducts,
        swiperCategories: swiperCategories,
        swiperFunctions: swiperFunctions,
        swiperVideos: swiperVideos,
        swiperProductGallery: swiperProductGallery,
        swiperDocumentation: swiperDocumentation,
    };

    var expandAreasCat = document.querySelectorAll(".expand-area.category");
    var contractAreasCat = document.querySelectorAll(".contract-area.category");
    var expandAreasProd = document.querySelectorAll(".expand-area.products");
    var contractAreasProd = document.querySelectorAll(
        ".contract-area.products"
    );
    expandAreasCat.forEach((expandArea, index) => {
        expandAreaFunction(expandArea, index);
    });
    contractAreasCat.forEach((contractArea, index) => {
        contractAreaFunc(contractArea, index);
    });
    expandAreasProd.forEach((expandArea, index) => {
        expandAreaFunction(expandArea, index);
    });
    contractAreasProd.forEach((contractArea, index) => {
        contractAreaFunc(contractArea, index);
    });
    function expandAreaFunction(expandArea, index) {
        expandArea.addEventListener("click", (e) => {
            expandArea.classList.add("d-none");
            expandArea.nextElementSibling.classList.remove("d-none");
            const slider = e.target.getAttribute("data-swiper");
            let container;
            if (sliders[slider].length > 1) {
                container = sliders[slider][index].el;
                sliders[slider][index].disable();
            } else {
                container = sliders[slider].el;
                sliders[slider].disable();
            }
            container.classList.add("container");
            const wrapper = container.querySelector(".swiper-wrapper");
            wrapper.classList.add("row", "expanded");
            const slides = container.querySelectorAll(".swiper-slide");
            slides.forEach((s) => {
                s.classList.add(
                    "col-12",
                    "col-sm-6",
                    "col-md-4",
                    "col-lg-55",
                    "mb-5",
                    "slide"
                );
                s.classList.remove("swiper-slide");
                s.style.marginRight = 0;
            });
            const nav = container.querySelector(".swiper-navigation");
            const pag = container.querySelector(".swiper-pagination");
            [nav, pag].forEach((el) => {
                el.classList.add("d-none");
            });
        });
    }
    function contractAreaFunc(contractArea, index) {
        contractArea.addEventListener("click", (e) => {
            contractArea.classList.add("d-none");
            contractArea.previousElementSibling.classList.remove("d-none");
            const slider = e.target.getAttribute("data-swiper");
            let container;
            if (sliders[slider].length > 1) {
                container = sliders[slider][index].el;
                sliders[slider][index].enable();
            } else {
                container = sliders[slider].el;
                sliders[slider].enable();
            }
            container.classList.remove("container");
            const wrapper = container.querySelector(".swiper-wrapper");
            wrapper.classList.remove("row", "expand");
            const slides = container.querySelectorAll(".slide");
            slides.forEach((s) => {
                s.classList.add("swiper-slide");
                s.classList.remove(
                    "col-12",
                    "col-sm-6",
                    "col-md-4",
                    "col-lg-3",
                    "mb-5"
                );
                s.style.marginRight = 15;
            });
            const nav = container.querySelector(".swiper-navigation");
            const pag = container.querySelector(".swiper-pagination");
            [nav, pag].forEach((el) => {
                el.classList.remove("d-none");
            });
        });
    }

    const mainMenu = document.querySelector("#main-menu");
    const submenuItems = document.querySelectorAll(
        "#menu-slide-menu > li.menu-item-has-children"
    );
    mainMenu.addEventListener("click", (e) => {
        const parent = e.target.parentNode;
        if (e.target.closest(".menu-item-has-children")) {
            const id = parent.getAttribute("id").replace("menu-item-", "");
            const submenu = document.querySelector("#submenu-" + id);
            submenu.classList.toggle("active");
        } else {
            const submenus = document.querySelectorAll(".submenu");
            submenus.forEach((sub) => {
                sub.classList.remove("active");
            });
        }
    });

    var menuButton = document.querySelector(".hamburger>a");
    var slideMainMenu = document.querySelector("#main-menu");
    var slideSubMenus = document.querySelectorAll(".submenu");
    var slideCloseMenu = document.querySelector("#main-menu .close");
    var slideCloseSubMenu = document.querySelector(".submenu .close");
    menuButton?.addEventListener("click", (e) => {
        e.preventDefault();
        toggleMenu(false);
    });
    slideCloseMenu?.addEventListener("click", (e) => {
        toggleMenu(true);
    });
    slideCloseSubMenu?.addEventListener("click", (e) => {
        slideSubMenus.forEach((menu) => {
            menu.classList.remove("active");
        });
    });
    // document.addEventListener("click", (e) => {
    //     var isClosest = e.target.closest(".hamburger>a");
    //     var child = slideMainMenu.contains(e.target);
    //     console.log(e.target);
    //     if (
    //         e.target !== menuButton &&
    //         e.target !== slideMainMenu &&
    //         !e.target.classList.contains("submenu") &&
    //         !isClosest &&
    //         !child
    //     ) {
    //         toggleMenu(true);
    //     }
    // });
    const toggleMenu = (open) => {
        if (slideMainMenu.classList.contains("active")) {
            slideMainMenu.classList.remove("active");
            setTimeout((e) => {
                slideMainMenu.classList.add("done");
            }, 350);
        } else {
            slideMainMenu.classList.remove("done");
            setTimeout((e) => {
                slideMainMenu.classList.add("active");
            }, 1);
        }
    };

    const productGallery = document.querySelector(
        ".product .entry-content .gallery .swiper-wrapper"
    );
    const productGalleryFull = document.querySelector(
        ".product .entry-content .gallery .swiper .swiper-full"
    );
    if (productGallery || productGalleryFull) {
        [productGallery, productGalleryFull].forEach((el) => {
            el.addEventListener("click", (e) => {
                var images = productGallery.querySelectorAll("img");
                var srcs = [];
                images.forEach((i) => {
                    srcs.push(i.getAttribute("data-full"));
                });
                openLightbox(srcs);
            });
        });
    }

    function openLightbox(srcs) {
        // Remove if existing
        const existing = document.getElementById("lightbox");
        if (existing) {
            existing.remove();
        }
        // Create lightbox
        const lightbox = document.createElement("div");
        lightbox.id = "lightbox";
        lightbox.classList.add("fullscreen");

        // Create slider setup with controls
        const swiper = createElementWithClass("div", ["swiper"]);
        const swiperWrapper = createElementWithClass("div", ["swiper-wrapper"]);
        const pagination = createElementWithClass("div", ["swiper-pagination"]);
        const navLeft = createElementWithClass("div", [
            "swiper-button",
            "prev",
        ]);
        const iLeft = createElementWithClass("i", ["bi", "bi-chevron-left"]);
        navLeft.appendChild(iLeft);
        const navRight = createElementWithClass("div", [
            "swiper-button",
            "next",
        ]);
        const iRight = createElementWithClass("i", ["bi", "bi-chevron-right"]);
        navRight.appendChild(iRight);
        const nav = createElementWithClass("div", ["swiper-nav"]);
        nav.appendChild(navLeft);
        nav.appendChild(navRight);
        srcs.forEach((s) => {
            const slide = createElementWithClass("div", ["swiper-slide"]);
            const img = createElementWithClass("img");
            img.setAttribute("src", s);
            slide.appendChild(img);
            swiperWrapper.appendChild(slide);
        });

        // Add slides to slider
        swiper.appendChild(swiperWrapper);
        // Add pagination
        swiper.appendChild(pagination);
        // Add navigation
        swiper.appendChild(nav);
        // Add slider to lightbox
        lightbox.appendChild(swiper);
        // Add close sign
        const close = createElementWithClass("i", ["bi", "bi-x-lg", "close"]);
        close.addEventListener("click", (e) => {
            closeLightbox();
        });
        lightbox.appendChild(close);
        // Add lightbox to body
        document.body.appendChild(lightbox);
        setTimeout(() => {
            // Add classes to lightbox
            lightbox.classList.add("visible");
            lightbox.classList.add("large");
        }, 50);

        Swiper.use([Navigation, Pagination]);
        const swiperProductLightbox = new Swiper(
            "#lightbox.fullscreen .swiper",
            {
                spaceBetween: 0,
                slidesPerView: 1,
                grabCursor: true,
                slidesPerGroup: 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button.next",
                    prevEl: ".swiper-button.prev",
                },
            }
        );
    }

    Swiper.use([Navigation, Pagination]);
    const swiperProductLightbox = new Swiper("#home-intro .swiper", {
        spaceBetween: 0,
        slidesPerView: 1,
        grabCursor: true,
        slidesPerGroup: 1,
        autoplay: true,
        autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    const modalButtons = document.querySelectorAll('[data-toggle="modal"]');
    modalButtons.forEach((e) => {
        if (e) {
            var target = e.getAttribute("data-target");
            e.addEventListener("click", () => {
                openModal(target);
            });
        }
    });
    const modals = document.querySelectorAll(".modal");
    modals.forEach((e) => {
        if (e) {
            var target = e.getAttribute("id");
            e.addEventListener("click", (e) => {
                if (e.target === e.currentTarget) {
                    closeModal(target);
                }
            });
        }
    });
    const closeModalIcons = document.querySelectorAll(".modal .close");
    closeModalIcons.forEach((i) => {
        i.addEventListener("click", (e) => {
            const target = i.getAttribute("data-target");
            if (target) {
                closeModal(target);
            }
        });
    });

    function openModal(target) {
        var backdrop = createElementWithClass("div", [
            "modal-backdrop",
            "show",
        ]);
        backdrop.setAttribute("data-target", target);
        backdrop.setAttribute("id", "backdrop");
        document.body.appendChild(backdrop);
        document.querySelector(target).style.display = "block";
        document.querySelector(target).classList.add("show");
        document.body.classList.add("overflow-hidden");
    }

    function closeModal(target) {
        document.getElementById("backdrop")?.remove();
        document.getElementById(target).style.display = "none";
        document.getElementById(target).classList.remove("show");
        document.body.classList.remove("overflow-hidden");
    }

    // // Get the modal
    // var modal = document.querySelector(target);

    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {
    //     if (event.target == modal) {
    //         closeModal()
    //     }
    // }

    function createElementWithClass(element, classes = []) {
        const el = document.createElement(element);
        if (classes.length) {
            classes.map((c) => {
                el.classList.add(c);
            });
        }
        return el;
    }

    function closeLightbox() {
        const lightbox = document.getElementById("lightbox");
        if (lightbox) {
            lightbox.classList.remove("large");
            setTimeout(() => {
                lightbox.remove();
            }, 300);
        }
    }

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closeLightbox();
            closeVideoModal();
            document
                .querySelectorAll("#product-menu .products.active")
                .forEach((item) => {
                    item.classList.remove("active");
                });
            document
                .querySelector("#product-menu .categories")
                .classList.remove("active");
            document.querySelectorAll(".modal").forEach((e) => {
                if (e) {
                    var id = e.getAttribute("id");
                    closeModal(id);
                }
            });
        }
    });

    function closeAndCleanSearch() {
        searchPopup.classList.remove("active");
        searchPopup.classList.remove("results");
        searchInput.value = "";
        searchInput.blur();
        searchResult.innerHTML = "";
    }

    // Search filter by post type
    const searchFilters = document.querySelectorAll(".search-filters .type");
    searchFilters.forEach((f) => {
        f.addEventListener("click", (e) => {
            if (e.target.classList.contains("none")) {
                return;
            }
            const url = new URL(location);
            let types = url.searchParams.get("type");
            types = types ? types.split("|") : [];
            const type = e.target.getAttribute("data-type");
            if (types.indexOf(type) >= 0) {
                const found = types.indexOf(type);
                types.splice(found, 1);
            } else {
                types.push(type);
            }
            types = types.filter((t) => {
                return t && t.length;
            });
            url.searchParams.delete("type");
            if (types.length) {
                url.searchParams.set("type", types.join("|"));
            }
            history.pushState({}, "", url);
            applySearchType(types);
        });
    });

    function applySearchType(types = []) {
        if (!types.length) {
            const url = new URL(location);
            let params = url.searchParams;
            types = params.get("type") ? params.get("type").split("|") : [];
        }
        const typeInput = document.querySelector('form input[name="type"]');
        typeInput.value = types.join("|");
        const domEl = document.querySelectorAll(".section-type");
        domEl.forEach((el) => {
            const dataType = el.getAttribute("data-type");
            if (types.indexOf(dataType) >= 0) {
                el.classList.add("d-block");
                el.classList.remove("d-none");
            } else {
                el.classList.remove("d-block");
                el.classList.add("d-none");
            }
        });
        const typeButtons = document.querySelectorAll(".search-filters .type");
        typeButtons.forEach((el) => {
            const dataType = el.getAttribute("data-type");
            if (types.indexOf(dataType) >= 0) {
                el.classList.add("btn-default");
                el.classList.remove("btn-outline");
            } else {
                el.classList.remove("btn-default");
                el.classList.add("btn-outline");
            }
        });
        if (types.length <= 0) {
            typeButtons.forEach((el) => {
                const dt = el.getAttribute("data-type");
                if (dt) {
                    types.push(dt);
                }
            });
            applySearchType(types);
        }
    }

    // const filters = document.querySelectorAll("#sidebar .filters input");
    // filters.forEach((el) => {
    //   el.addEventListener("change", (e) => {
    //     // get info from checkbox
    //     const type = e.target.getAttribute("name");
    //     const val = e.target.value;
    //     const isChecked = e.target.checked;
    //     // get applied filters from URL
    //     const url = new URL(location);
    //     let types = url.searchParams.get(type);
    //     if (types && types.length > 0) {
    //       types = types.split(",");
    //     } else {
    //       types = [];
    //     }
    //     if (isChecked) {
    //       types.push(val);
    //     } else {
    //       const i = types.indexOf(val);
    //       types.splice(i, 1);
    //     }
    //     if (types.length) {
    //       url.searchParams.set(type, types.join(","));
    //     } else {
    //       url.searchParams.delete(type);
    //     }
    //     history.pushState({}, "", url);
    //   });
    // });

    const productMenu = document.querySelector("#product-menu .categories");
    const productMenuToggle = document.querySelectorAll("a[href='#products']");
    productMenuToggle.forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            productMenu.classList.toggle("active");
        });
    });

    const menuItems = document.querySelectorAll(
        "#product-menu .categories li > a[href^='#']"
    );
    menuItems.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            const href = item.getAttribute("href").replaceAll("#", "");
            const categMenu = document.querySelector(
                "#product-menu #products-" + href
            );
            const openMenus = document.querySelectorAll(
                "#product-menu .products.active"
            );
            openMenus.forEach((item) => {
                if (categMenu !== item) {
                    item.classList.remove("active");
                }
            });
            let timeout = 0;
            if (openMenus.length >= 1) {
                timeout = 300;
            }
            setTimeout(() => {
                categMenu.classList.add("active");
            }, timeout);
        });
    });

    const closeMenu = document.querySelectorAll("#product-menu i.close");
    closeMenu.forEach((i) => {
        i.addEventListener("click", (e) => {
            const parent = i.closest(".categories") || i.closest(".products");
            const openMenus = document.querySelectorAll(
                "#product-menu .products.active"
            );
            openMenus.forEach((item) => {
                item.classList.remove("active");
            });
            parent.classList.remove("active");
        });
    });

    // When the user scrolls the page, execute myFunction
    window.onscroll = function () {
        myFunction();
    };
    // Get the header
    var header = document.querySelector(".navigation.fixed-top");

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
        if (window.pageYOffset > 10) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }

    function faqAccordion(close = false) {
        const faqToggle = document.getElementById("faq-toggle");
        if (faqToggle) {
            const faqHeading = faqToggle.querySelectorAll(".faq-heading");
            const faqContent = faqToggle.querySelectorAll(".faq-content");
            const faqHeights = [];
            if (close) {
                faqHeading.forEach((h, i) => {
                    faqContent[i].style.maxHeight = null;
                    faqContent[i].classList.remove("active");
                    h.classList.remove("active");
                });
                return;
            }
            faqContent.forEach((c, i) => {
                faqHeights[i] = c.offsetHeight;
                c.style.maxHeight = 0;
            });
            faqHeading.forEach((h, i) => {
                h.addEventListener("click", (e) => {
                    if (e.target.classList.contains("active")) {
                        faqContent[i].style.maxHeight = "0px";
                        faqContent[i].classList.remove("active");
                        e.target.classList.remove("active");
                        return;
                    }
                    faqContent.forEach((c, i) => {
                        c.classList.remove("active");
                        faqHeading[i].classList.remove("active");
                        c.style.maxHeight = "0px";
                    });
                    const _this = e;
                    setTimeout(() => {
                        if (faqContent[i].classList.contains("active")) {
                            faqContent[i].style.maxHeight = "0px";
                            faqContent[i].classList.remove("active");
                            _this.target.classList.remove("active");
                        } else {
                            faqContent[i].style.maxHeight =
                                faqHeights[i] + "px";
                            faqContent[i].classList.add("active");
                            _this.target.classList.add("active");
                        }
                    }, 1);
                });
            });
        }
    }

    // Cookie service for easy use
    const CookieService = {
        setCookie(name, value, days) {
            let expires = "";

            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }

            document.cookie = name + "=" + (value || "") + expires + ";";
        },

        getCookie(name) {
            const cookies = document.cookie.split(";");

            for (const cookie of cookies) {
                if (cookie.indexOf(name + "=") > -1) {
                    return cookie.split("=")[1];
                }
            }

            return null;
        },
    };

    const mouseExitModal = document.querySelector(".exit-intent-bg");
    if (mouseExitModal) {
        // Open exit intent
        const mouseEvent = (e) => {
            const shouldShowExitIntent =
                !e.toElement && !e.relatedTarget && e.clientY < 10;

            if (shouldShowExitIntent) {
                document.removeEventListener("mouseout", mouseEvent);
                mouseExitModal.classList.add("visible");
                CookieService.setCookie("exitIntentShown", true, 30);
            }
        };

        // function to close exit intent
        const exit = (e) => {
            const shouldExit =
                [...e.target.classList].includes("exit-intent-bg") ||
                [...e.target.classList].includes("close") || // user clicks on the close icon
                e.keyCode === 27; // user hits escape

            if (shouldExit) {
                document
                    .querySelector(".exit-intent-bg")
                    .classList.remove("visible");
            }
        };

        if (!CookieService.getCookie("exitIntentShown")) {
            setTimeout(() => {
                document.addEventListener("mouseout", mouseEvent);
                document.addEventListener("keydown", exit);
            }, 10);
        }

        // Detect if mouse intent is clicked to be closed
        mouseExitModal.addEventListener("click", exit);
    }
})();
